var map = {
	"./pitch_centreAttackingMidfielder.svg": 9741,
	"./pitch_centreBack.svg": 3018,
	"./pitch_centreDefensiveMidfielder.svg": 1976,
	"./pitch_centreForward.svg": 8127,
	"./pitch_centreMidfielder.svg": 4181,
	"./pitch_empty.svg": 1087,
	"./pitch_goalkeeper.svg": 7189,
	"./pitch_leftAttackingMidfielder.svg": 2466,
	"./pitch_leftBack.svg": 5230,
	"./pitch_leftCentreBack.svg": 1429,
	"./pitch_leftCentreForward.svg": 9551,
	"./pitch_leftCentreMidfielder.svg": 7042,
	"./pitch_leftDefensiveMidfielder.svg": 7809,
	"./pitch_leftMidfielder.svg": 2236,
	"./pitch_leftWing.svg": 9810,
	"./pitch_leftWingBack.svg": 6972,
	"./pitch_rightAttackingMidfielder.svg": 5069,
	"./pitch_rightBack.svg": 2193,
	"./pitch_rightCentreBack.svg": 1714,
	"./pitch_rightCentreForward.svg": 8335,
	"./pitch_rightCentreMidfielder.svg": 6359,
	"./pitch_rightDefensiveMidfielder.svg": 9412,
	"./pitch_rightMidfielder.svg": 388,
	"./pitch_rightWing.svg": 3982,
	"./pitch_rightWingBack.svg": 2385,
	"./pitch_secondaryStriker.svg": 4656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1333;